import { useEffect, useState } from "react";

export const CountdownTimer = ({ targetDate }) => {
	const calculateTimeLeft = () => {
		const difference = new Date(targetDate) - new Date();
		if (difference <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

		return {
			days: Math.floor(difference / (1000 * 60 * 60 * 24)),
			hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
			minutes: Math.floor((difference / (1000 * 60)) % 60),
			seconds: Math.floor((difference / 1000) % 60),
		};
	};

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);

		return () => clearInterval(timer);
	}, [targetDate]);

	return (
		<div className="flex justify-between items-center gap-4 text-[56px] font-semibold">
			<div className="flex flex-col gap-1"> <span>{timeLeft.days}</span> <span className="text-base text-opacity-80">Days</span> </div>
			<div className="flex flex-col gap-1"> <span>{timeLeft.hours}</span> <span className="text-base text-opacity-80">Hours</span></div>
			<div className="flex flex-col gap-1"> <span>{timeLeft.minutes}</span> <span className="text-base text-opacity-80">Minutes</span></div>
			<div className="flex flex-col gap-1"> <span>{timeLeft.seconds}</span> <span className="text-base text-opacity-80">Seconds</span></div>
		</div>
	);
};